import React from "react";
import "./About.css";
import Selfie from "../../Assets/Images/Selfie.jpg";
import { TbAward } from "react-icons/tb";
import { ImUsers } from "react-icons/im";
import { ImFolderOpen } from "react-icons/im";
import Link from "react-scroll/modules/components/Link";
export default class About extends React.Component {
	render() {
		return (
			<section id="#about">
				<h5>Get To Know</h5>
				<h2>About Me</h2>

				<div className="container about__container">
					<div
						className="about__me"
						data-aos="zoom-out"
						data-aos-duration="4000"
					>
						<img src={Selfie} alt="profile" className="about__profile" />
					</div>

					<div className="about__content">
						{/* [ ] Cards */}
						<div className="about__cards">
							<article
								className="about__card"
								data-aos="flip-left"
								data-aos-duration="2000"
							>
								<TbAward className="about__icon" />
								<h5>Experience</h5>
								<small>1+ Years</small>
							</article>

							<article
								className="about__card"
								data-aos="flip-up"
								data-aos-duration="2000"
							>
								<ImFolderOpen className="about__icon" />
								<h5>Public Projects</h5>
								<small>20+</small>
							</article>

							<article
								className="about__card"
								data-aos="flip-right"
								data-aos-duration="2000"
							>
								<ImUsers className="about__icon" />
								<h5>Clients</h5>
								<small>N.D.A</small>
							</article>
						</div>
						{/* [x] End of Cards */}
						<p>
							I am currently doing commission/freelance work on websites such as
							upwork and fiverr. On the side I continue to work on my skills and
							will be updating this website in due course since most of the
							information such as my skill set is outdated. I would like to
							inform you that you will find a more up to date representation of
							my skills on my CV. Below is my history and passion for
							programming and I hope you enjoy your stay here.
							<br />
							<br />
							As a full stack web developer with seven years of experience in
							the healthcare industry, I have developed strong skills in
							relationship building, strategic planning, and project management.
							I have a proven track record of being able to quickly learn and
							adapt to new and complex situations. In addition to my
							professional experience, I am committed to lifelong learning and
							personal development. I have completed several training programs
							to further my skills as a developer, including a web development
							program with the Scion Coalition Scheme, where I studied front-end
							and back-end development, including UI/UX design, mobile
							development, object-oriented programming, and databases. I also
							completed a four-month full-time Bootcamp focused on the MERN
							stack with Tech Educators UK, which provided a comprehensive,
							hands-on introduction to these technologies and their use in
							modern web development. The program was 40 hours per week and
							provided a challenging, yet rewarding learning experience. Through
							this program, I gained valuable soft skills.
							<br />
							<br />
							In my free time, I enjoy playing chess and reading. I have been
							playing chess as a hobby for several years and have become quite
							skilled at the game. Playing chess regularly helps me to remain
							analytical and think logically, which has been beneficial in many
							ways. I also have a passion for reading and enjoy both fiction and
							non-fiction. Reading has improved my concentration, expanded my
							knowledge and vocabulary, and exposed me to new ideas. Overall,
							reading is an enjoyable and enriching hobby for me.
						</p>

						<Link
							to="#contact"
							spy={true}
							smooth={true}
							offset={50}
							duration={500}
							isDynamic={true}
							className="btn btn-primary"
						>
							Let's Chat
						</Link>
					</div>
				</div>
			</section>
		);
	}
}
